<div class="modal-wrapper">
  <div id="limit-container">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <h5 class="modal-title">{{ title }}</h5>
        </ion-col>
        <ion-col size="12">
          <p>{{ message }}</p>
        </ion-col>
      </ion-row>

      <ion-row id="limit-container-footer">
        <ion-col size="12">
          <button (click)="cancel()" type="button" mat-raised-button color="warn" class="me-3">{{ cancelText }}</button>
          <button (click)="confirm()" type="button" mat-raised-button color="primary">{{ confirmText }}</button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
